/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useStore } from "vuex";
import { removeAllCookie } from "@/shared/utils/cookie";
import { ref } from "vue";
import { registrationSimpleStore } from "@/shared/store/simpleStore/registrationData";

/**
 * This is separated from useLogout composable to have a chance
 * to show splash screen while resetting the values on vuex store
 * and local storage
 */
export default function useResetCache() {
  const store = useStore();

  // manually set the loading value to true/false
  const resetCacheLoading = ref(false);

  const resetCache = async () => {
    resetCacheLoading.value = true;
    // Also reset value of registration simple store upon logout
    registrationSimpleStore.resetStore();

    removeAllCookie();
    window.sessionStorage.clear();

    // Keys to retain on local storage
    const keysToRetain = ["cookieConsent"];

    // convert local storage object to array
    const localStorageArr = Object.keys(window.localStorage);

    // remove the keys from local storage except cookie consent
    localStorageArr.forEach((key) => {
      // if the current key (e.g. cookieConsent) exists in keysToRetain array, return
      if (keysToRetain.includes(key)) return;

      // delete other keys
      window.localStorage.removeItem(key);
    });

    // resetting vuex store
    await store.dispatch("logoutSuccess");

    // Delay for 2 seconds to properly show the Splash screen
    setTimeout(() => {
      resetCacheLoading.value = false;
      // FIXME: Temporary fix for token auth error. Force reload after splashscreen
      window.location.reload();
    }, 1000);
  };

  return {
    resetCache,
    resetCacheLoading,
  };
}
